import request from "api/axiosClient";

export const getDataOnlineStoreReport = async (values) => {
    const result = await request({
        url: "online-store-report/data-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}

export const getOnlineStoreReportGraphical = async (values) => {
    const result = await request({
        url: "online-store-report/graphical-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}